import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './i18n'
import { SnackbarProvider } from 'notistack';
import { AuthProvider } from './context/AuthProvider';
import initConsoleFilter from './utils/consoleFilter';
import { applyTheme } from './utils/applyTheme';

initConsoleFilter();

applyTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <SnackbarProvider maxSnack={3} anchorOrigin={{
    vertical: 'bottom',
    horizontal: 'right',
  }}>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AuthProvider>
        <Routes>
          <Route path="/*" element={<App />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </SnackbarProvider>


);

reportWebVitals();